import {NgModule} from '@angular/core';
import {CmsConfig, provideConfig} from '@spartacus/core';
import {PERSONALIZATION_FEATURE} from '@spartacus/tracking/personalization/root';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    provideConfig({
      featureModules: {
        [PERSONALIZATION_FEATURE]: {
          module: () =>
            import('../../../personalization/tracking/dcp-dtrum-tracking-feature.module').then(
              (m) => m.DcpDtrumTrackingFeatureModule
            ),
        },
      },
    } as CmsConfig),
  ],
})
export class DcpDtrumTrackingFeatureWrapperModule {}
